import { apiClient } from './client';
import {
  Company,
  CreateCompanyPayload,
  CompanySearchItem,
  JoinRequest,
  UpdateCompanyPayload,
} from '../types/company';

export async function fetchMyCompanies(): Promise<Company[]> {
  const { data } = await apiClient.get<Company[]>('/companies');
  return data;
}

export async function fetchCurrentCompany(): Promise<Company> {
  const { data } = await apiClient.get<Company>('/companies/current');
  return data;
}

export async function updateCompany(payload: UpdateCompanyPayload): Promise<Company> {
  const { data } = await apiClient.patch<Company>('/companies/current', payload);
  return data;
}

export async function uploadCompanyLogo(file: File): Promise<Company> {
  const formData = new FormData();
  formData.append('logo', file);
  const { data } = await apiClient.post<Company>('/companies/current/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteCompanyLogo(): Promise<void> {
  await apiClient.delete('/companies/current/logo');
}

export async function scheduleCompanyDeletion(confirmation: string): Promise<Company> {
  const { data } = await apiClient.post<Company>('/companies/current/deletion', { confirmation });
  return data;
}

export async function cancelCompanyDeletion(): Promise<Company> {
  const { data } = await apiClient.delete<Company>('/companies/current/deletion');
  return data;
}

export async function fetchCompanyLogoUrl(): Promise<string> {
  const { data } = await apiClient.get<Blob>('/companies/current/logo', {
    responseType: 'blob',
  });
  return window.URL.createObjectURL(data);
}

export async function createCompany(payload: CreateCompanyPayload): Promise<Company> {
  const { data } = await apiClient.post<Company>('/companies', payload);
  return data;
}

export async function searchCompanies(keyword: string): Promise<CompanySearchItem[]> {
  const { data } = await apiClient.get<CompanySearchItem[]>('/companies/search', {
    params: { q: keyword },
  });
  return data;
}

export async function createJoinRequest(companyId: number): Promise<JoinRequest> {
  const { data } = await apiClient.post<JoinRequest>('/companies/join-requests', { companyId });
  return data;
}

export async function fetchIncomingJoinRequests(): Promise<JoinRequest[]> {
  const { data } = await apiClient.get<JoinRequest[]>('/companies/join-requests');
  return data;
}

export async function approveJoinRequest(joinRequestId: number): Promise<JoinRequest> {
  const { data } = await apiClient.post<JoinRequest>(
    `/companies/join-requests/${joinRequestId}/approve`
  );
  return data;
}

export async function rejectJoinRequest(joinRequestId: number): Promise<JoinRequest> {
  const { data } = await apiClient.post<JoinRequest>(
    `/companies/join-requests/${joinRequestId}/reject`
  );
  return data;
}
